import { render, staticRenderFns } from "./MobileFooterComponent.vue?vue&type=template&id=2119a1ef&lang=pug&"
var script = {}
import style0 from "./MobileFooterComponent.vue?vue&type=style&index=0&id=2119a1ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports